import LiveFeedback from './LiveFeedback';
import { useCallback, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import styled from 'styled-components';
import StartNotificationSheet from '../../LiveManage/StartNotificationSheet';

export default function SellerStartNotification({ liveSeq, status }: { liveSeq: number; status: string }) {
  const storageKey = `fanbird.startNotification.dismissed.${liveSeq}`;
  const [dismissed, setDismissed] = useState(() => {
    try { return sessionStorage.getItem(storageKey) === '1'; } catch { return false; }
  });
  const [sent, setSent] = useState(false);
  const dismiss = useCallback(() => {
    setDismissed(true);
    try { sessionStorage.setItem(storageKey, '1'); } catch { /* Keep the choice for this mounted page. */ }
  }, [storageKey]);
  const accepted = useCallback(() => { dismiss(); setSent(true); }, [dismiss]);

  useEffect(() => {
    if (!sent) return;
    const timer = window.setTimeout(() => setSent(false), 5000);
    return () => window.clearTimeout(timer);
  }, [sent]);

  if (status !== '방송중') return null;
  return <>
    {!dismissed && <StartNotificationSheet liveSeq={liveSeq} onDismiss={dismiss} onSent={accepted} />}
    {sent && createPortal(<Feedback as={LiveFeedback} fallbackAs="div" role="status">시작 알림톡 발송을 접수했습니다.</Feedback>, document.body)}
  </>;
}

const Feedback = styled.div`
  position: fixed;
  bottom: calc(24px + env(safe-area-inset-bottom));
  left: 50%;
  transform: translateX(-50%);
  z-index: 1300;
  max-width: calc(100% - 48px);
  padding: 14px 20px;
  border-radius: 12px;
  background: var(--admin-theme-surface, #211e29);
  color: var(--admin-theme-text, #fff);
  box-shadow: 0 4px 20px #0003;
  font: var(--font-weight-regular) 14px/1.5 var(--font-family-base);
  text-align: center;
`;
